import { defineComponent as _defineComponent } from 'vue'
import { globalParam } from '@/helpers/globals';


export default /*#__PURE__*/_defineComponent({
  __name: 'PublishInfoCard',
  props: {
    height: {
        type: [String, Number],
        default: null,
    },
},
  setup(__props) {



return { __sfc: true,globalParam }
}

})